/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Nav from '../layouts/Nav';
import Footer from '../layouts/Footer';
import { UseAccounts } from '../../hooks/accounts/useAccounts';

const Accounts = () => {
  const [{ accounts, isLoading }] = UseAccounts();

  return (
    <span>
      <Nav />
      <div className="container" id="content">
        <div className="row">
          <div className="col-md-6 col-12 m-auto">
            <p className="mt-4">My Accounts</p>
            {isLoading ? (
              <small>loading...</small>
            ) : (
              accounts.map((account) => (<div className="container box2 p-3" key={account.name}>
                  <div className="row">
                    <div className="col-sm-12 d-flex mt-2">
                      <div className="">
                        <img
                          src="images/house.png"
                          alt="House"
                          className="mr-3 ml-5"
                        />
                      </div>
                      <div>
                        <span className="font_20 bolder_font">
                          {account.name}
                        </span>
                        {/* <p className="font_16 lighter_font">Business Unlimited</p> */}
                      </div>
                    </div>
                  </div>
                </div>))
            )}
            <div className="mt-4">
              <button type="button" className="btn btn-grey w-100">
                MANAGE
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </span>
  );
};

Accounts.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  accounts: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default Accounts;
